/*
 * Author: Danny Ehlers
 * Date: 3/17/2019
 * Used for the login process.
 */

import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
//import { OpenIdConnectService } from '../services/security/open-id-connect.service';
import { SettingsProviderService } from '../settings-provider.service';
import { CapSpinnerService } from '../core/cap-spinner/services/cap-spinner.service';
import { TutorialService } from '../modules/tutorial/tutorial.service';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { AuthService } from '../services/security/auth.service';
import { takeUntil } from 'rxjs';
import { Subject, switchMap, catchError, EMPTY, of, filter, tap } from 'rxjs';
import { AuthUser } from '../model/auth-user';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  display: boolean = false;
  environmentName: string;
  version: string;
  announcements: any[] = [];
  Tutorials: any[];
  modalRef: BsModalRef;
  @ViewChild('template') templateRef: TemplateRef<any>;
  modalConfig = {
    class: 'modal-lg modal-transparent'
  }

  videoUrl: SafeResourceUrl;
  thumbnailUrl: string = "";

  private destroy$: Subject<void> = new Subject(); 
  user: AuthUser;

  constructor(
    public authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private settingsProviderService: SettingsProviderService,
    private capSpinnerService: CapSpinnerService,
    private tutorialService: TutorialService,
    private sanitized: DomSanitizer,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.environmentName = this.settingsProviderService.configuration.envName;
    this.version = this.settingsProviderService.configuration.version;
    this.capSpinnerService.spinnerHide();
    this.settingsProviderService.getAnnouncements().subscribe(result => {
      if (result.isSuccess) {
        this.announcements = result.data;
        console.log(this.announcements);
      }
    }, error => console.error(error));
    
    this.tutorialService.getTutorials().subscribe(response => {
      this.Tutorials = response;

      if (this.Tutorials.length > 0) {
        var vUrl = this.Tutorials[0].link;
        this.videoUrl = this.sanitized.bypassSecurityTrustResourceUrl(vUrl);
        var code = vUrl.replace("https://www.youtube.com/embed/", "");
        this.thumbnailUrl = "https://img.youtube.com/vi/" + code + "/0.jpg";
      }
    });

    

    this.authService.authUserObservable$
      .pipe(
        takeUntil(this.destroy$),       
        filter((b2cUser: AuthUser | undefined) =>
          !!b2cUser), // Only proceed if user exists
        switchMap(() =>
          this.authService.performSignIn()), // Perform sign-in within the stream
        tap(() => this.redirect()) // Redirect after successful sign-in
      )
      .subscribe(r => r);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  login(event): void {
    const path = this.getPath();
    if (path !== '/signin-oidc') {
      this.authService.login();
    }
  }

  redirect() {
    this.router.navigateByUrl(
      this.router.createUrlTree(['/dashboard'], { relativeTo: this.route })
    );
  }

  getPath(): string {
    return window.location.pathname;
  }

  scrollInvisiblity() {
    var c = this.announcements.length > 1 ? 'visible' : 'invisible';
    return c;
  }

  showDialog() {
    this.display = true;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.modalConfig);
  }
}
